<template>
  <nuttrema-layout-three-vertical class="is-in-mobile-ready-layout">

    <participant-standard-header
       slot="top"
       v-if="!loading"
      :meta="meta"
      :edit.sync="edit"
      :showEdit="true"
      :showOnMobileAndTablet="showOnMobileAndTablet">
    </participant-standard-header>

    <template slot="middle">
      <nuttrema-loader v-if="loading"></nuttrema-loader>
      <form-my-preferences-personal
         v-else
        :edit.sync="edit"
        :personIsProfessional="false"
        :theme="showOnMobileAndTablet ? 'west-top' : null"
        :labelPosition="showOnMobileAndTablet ? 'top' : null"
        :PersonalProfile="PersonalProfile"
        :PersonalLifeStages="PersonalLifeStages"
        :RegionalAndLanguageAll="RegionalAndLanguageAll"
        @submit="onFormSubmit">
      </form-my-preferences-personal>
    </template>

  </nuttrema-layout-three-vertical>
</template>

<script>
import { get } from 'lodash';
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import ResponsiveMonitor from 'components/mixins/responsive-monitor';

import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';
import FormMyPreferencesPersonal from 'components/pages/professional/settings/my-preferences/personal/form-my-preferences-personal';

export default {
  name: 'page-participant-my-preferences',
  mixins: [
    PageProps,
    ResponsiveMonitor,
  ],
  components: {
    ParticipantStandardHeader,
    FormMyPreferencesPersonal,
    NuttremaLayoutThreeVertical,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    RegionalAndLanguageAll() {
      return this.$store.getters.RegionalAndLanguageAll;
    },
    PersonalLifeStages() {
      return this.$store.getters.PersonalLifeStages;
    },
    loading() {
      return this.PersonalProfile.fetching || this.PersonalLifeStages.fetching || this.RegionalAndLanguageAll.fetching;
    },
  },
  methods: {
    ...mapActions([
      'SavePersonalProfile',
    ]),
    toggleSidebar() {
      this.$refs.mobileLayout.toggleSidebar();
    },
    onFormSubmit(payload) {
      return this.SavePersonalProfile({ payload })
        .then(() => {
          this.successNotification();
        }).catch(() => {
          this.errorNotification();
        });
    },
  },
  created() {
    const id = get(this.PersonalProfile, 'data.id', false);
    if (!id) this.$store.dispatch('GetPersonalProfile');

    this.$store.dispatch('GetPersonalLifeStages');
    this.$store.dispatch('GetRegionalAndLanguageAll', { language_app_support: true, measurement_system_optional: true });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonalLifeStages');
    this.$store.dispatch('ClearRegionalAndLanguageAll');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/participant/my-preferences/page-participant-my-preferences.vue